import React  from 'react';
import PropTypes from 'prop-types';

import Classes from 'classnames';

export default function OpenAllInList(props) {

    const { tasksOpen, tasksTotal } = props.item;

    const open = (tasksOpen ? tasksOpen : 0) + (props.childrenOpenCount ? props.childrenOpenCount : 0);
    const total = (tasksTotal ? tasksTotal : 0) + (props.childrenTotalCount ? props.childrenTotalCount : 0);

    const classes = Classes("gd-field-open-all", "list", props.className);

    return (
        <div className={classes}>
            <div className="open-tasks">{open}</div>
            <div className="all-tasks">/ {total}</div>
        </div>
    );
}

OpenAllInList.propTypes = {
    item: PropTypes.object,
    childrenOpenCount: PropTypes.number,
    childrenTotalCount: PropTypes.number
};